// extracted by mini-css-extract-plugin
export default {"loadingSideNav":"LoadingMenu_loadingSideNav__RyuSr","flashing":"LoadingMenu_flashing__aPlWb","invisibleTitle":"LoadingMenu_invisibleTitle__a4Kwl"};